import React, { useMemo } from 'react';

import { UseBaseTable } from 'hooks/useBaseTable';

import { UserAccessStatus } from 'api/endPoints/GetReportAccessStatus';

import NoData from 'components/common/NoData/noData';
import { TableV8 } from 'components/common/Tables/TableV8/tableV8';

import classes from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/ReportAccessSettings.module.scss';
import tableClasses from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/SpecificUsersAccess/components/UsersAccessTable/UsersAccessTable.module.scss';
import { usersAccessTableColumns } from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/SpecificUsersAccess/components/UsersAccessTable/UsersAccessTable.utils';

interface Props {
    userList: UserAccessStatus[];
    isLoading: boolean;
    isFetching: boolean;
    table: UseBaseTable['table'];
}

export const UsersAccessTable = ({ userList, isFetching, isLoading, table }: Props) => {
    const userListWithClassname = useMemo(() => {
        return (userList || []).map((user) => ({
            ...user,
            className: !user.canHaveAccess ? tableClasses.grayedOutRow : '',
        }));
    }, [userList]);

    return (
        <TableV8<UserAccessStatus>
            data={userListWithClassname}
            columns={usersAccessTableColumns}
            isLoading={isLoading}
            noData={<NoData>No data</NoData>}
            sorting={table.sorting}
            setSorting={table.setSorting}
            pagination={table.pagination}
            columnVisibility={table.columnVisibility}
            setColumnVisibility={table.setColumnVisibility}
            columnOrder={table.columnOrder}
            setColumnOrder={table.setColumnOrder}
            columnFilters={table.columnFilters}
            manualSorting={false}
            manualPagination={false}
            manualFiltering={false}
            rowSelection={table.rowSelection}
            setRowSelection={table.setRowSelection}
            ref={table.tableRef}
            tableClassName={classes.table}
            wrapperClassName={classes.wrapper}
            rowClassName={classes.row}
            totalPages={table.totalPages}
            setPagination={table.setPagination}
            isPaginationDisabled={isFetching}
            displayPaginationBottomBar
        />
    );
};
